export const queryKeys = {
  plantSiteDetails: 'plantSiteDetails',
  plantFuelTypes: 'plantFuelTypes',
  equipmentAttachmentType: 'equipmentAttachmentType',
  associatedUnitType: 'associatedUnitType',
  plantConfig: 'plantConfig',
  productType: 'productType',
  plantProfileType: 'plantProfileType',
  manufacturerType: 'manufacturerType',
  documents: 'documents',
  header: 'header',
  accountSettings: 'accountSettings',
  unit: 'unit',
  unitGetAll: 'unitGetAll',
  ommanualSectionGetAll: 'ommanualSectionGetAll',
  PartsCatalogSectionGetAll: 'PartsCatalogSectionGetAll',
  partsAndServices: 'partsAndServices',
  issueReports: 'issueReports',
  issueReportItems: 'issueReportItems',
  user: 'user',
  KPI: 'KPI',
  QuoteRequest: 'QuoteRequest',
  QuoteRequestItems: 'QuoteRequestItems',
  getEquipmentAttachmentFile: 'getEquipmentAttachmentFile',
  equipmentAttachment: 'equipmentAttachment',
  getAllPlantEquipmentsAttachments: 'getAllPlantEquipmentsAttachments',
  plantConfigImage: 'plantConfigImage',
  plantEquipment: 'plantEquipment',
  plantEquipments: 'plantEquipments',
  plantContacts: 'plantContacts',
  plantContact: 'plantContact',
  plantContactAvatar: 'plantContactAvatar',
  unitConfigurationTypes: 'unitConfigurationTypes',
  contractBasisTypes: 'contractBasisTypes',
  equipmentModelNameTypes: 'equipmentModelNameTypes',
  genrateReport: 'genrateReport',
  technicalbulletin: 'technicalbulletin',
  getAllQuoteRequestType: 'getAllQuoteRequestType',
  getAllRequestPriority: 'getAllRequestPriority',
  getAllPartsRequestReasons: 'getAllPartsRequestReasons',
  getAllQuoteTypes: 'getAllQuoteTypes',
  getAllOutageSeasons: 'getAllOutageSeasons',
  apiquoterequest: 'apiquoterequest',
  File: 'File',
  getFaqApi: 'getFaqApi',
  discussionGroups: 'discussionGroups',
  getQuoteRequestDocument: 'getQuoteRequestDocument',
  DeleteFile: 'DeleteFile',
  NamePlateFile: 'File',
  PartsFile: 'File',
  getQuoteRequest: 'getQuoteRequest',
  getQuoteRequestAttachments: 'getQuoteRequestAttachments',
  getAllCustomerSurveys: 'getAllCustomerSurveys',
  getAllServiceRequestReasons: 'getAllServiceRequestReasons',
  roleModulePermissions: 'roleModulePermissions',
  maintenanceModeCheck: 'maintenanceMode.get'
};